import { render, staticRenderFns } from "./UserBirthday.vue?vue&type=template&id=392c729c&scoped=true"
import script from "./UserBirthday.vue?vue&type=script&lang=js"
export * from "./UserBirthday.vue?vue&type=script&lang=js"
import style0 from "./UserBirthday.vue?vue&type=style&index=0&id=392c729c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c729c",
  null
  
)

export default component.exports